import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IssuePage.css'

@CSSModules(Styles, {allowMultiple:true})
export default class IssueFossilFuelFinanceInsurance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issue: Fossil fuel finance & insurance',
      description: 'Lorem ipsum',
      url: config.domain + config.routes.issueFossilFuelFinanceInsurance
    }
  }

  render() {
    return (
      <div styleName='page issue-ffbi'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <section styleName='section'>
            <h1 styleName='issue-top-label'>
              The issue: <span>Fossil fuel finance & insurance</span>
            </h1>
            <h2 styleName='issue-top-headline'>
             Financial companies are supporting fossil fuels
            </h2>
            <h3 styleName='issue-top-copy'>
              Banks and insurers that finance and underwrite fossil fuels - including tar sands, arctic drilling, and coal mining - may be hidden in your 401(k).
            </h3>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  <h2>Retirement plans are invested in climate-risk finance</h2>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    Commercial and investment banks are lending to fossil fuel companies, despite this carbon-intensive funding being fundamentally incompatible with reaching the 1.5-degree aligned global goal necessary to prevent catastrophic climate harm.
                  </p>
                  <p>
                    Primary insurers and reinsurers are also continuing to underwrite and invest in coal, oil, and gas, while experiencing dramatic losses associated with catastrophic weather-related events.
                  </p>
                  <p>
                    By continuing to financially support fossil fuel projects, banks and insurers are not only responsible for exacerbating climate and social impacts, but they are also exposing investors to financial risks.
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <h2 styleName='issue-focus-label'>
                    FOCUS: SUSTAINABILITY RISK
                  </h2>
                  <h3 styleName='issue-focus-headline'>
                    Banks financing fossil fuels
                  </h3>
                  <div styleName='issue-focus-copy'>
                    <p>
                      Since the Paris Agreement, the world's 60 largest banks
                      have provided $6.9 trillion in financing to the fossil
                      fuel industry, contributing to the climate crisis and
                      resulting in substantial portfolio risk for investors.
                    </p>
                    <p>
                      401(k) participants deserve to understand the climate risk embedded in their portfolios from these financial institutions.
                    </p>
                    <p>
                      <Link
                        to={config.routes.companies + '#fossilfinance'}
                        title='Companies: Fossil fuel finance'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-solutions-label'>
                      The Solutions
                    </h2>
                    <h3 styleName='issue-solutions-headline'>
                      Offer climate-safe retirement plan options
                    </h3>
                    <div styleName='issue-solutions-copy'>
                      <p>
                        Company retirement plans should offer fund options that are sustainably invested and climate-safe, avoiding investments in fossil fuels, including climate-risk financial companies.
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.solutionOfferSustainability}
                        title='Solution: Offer sustainability'
                        xstrong
                      >
                        Explore solutions<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-faqs-label'>
                      FAQs
                    </h2>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing the climate crisis.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
